import { InlineErrorMessage, Label } from '@atoms/*';
import { FunctionComponent, ReactNode } from 'react';

type MessageProps = {
  path: string;
  message: string;
};

interface DateAndTimeProps {
  labelText: string;
  description: string;
  children: ReactNode;
  errorPath: string;
  errorMessages: MessageProps[];
}

export const DateAndTimeTemplate: FunctionComponent<DateAndTimeProps> = ({
  labelText,
  description,
  children,
  errorPath,
  errorMessages,
}) => {
  return (
    <section className="flex flex-col gap-y-1">
      <Label
        className={`!text-brand text-bodyLg font-semibold`}
        id={errorPath ?? labelText.toLowerCase().replaceAll(' ', '-')}
        htmlFor={labelText.toLowerCase().replaceAll(' ', '-')}
        text={labelText}
        isTitle={false}
      />
      <p data-testid="description" className="text-dark-grey text-bodyLg">
        {description}
      </p>
      <InlineErrorMessage path={errorPath} messages={errorMessages} />
      <section className="-mt-3 flex flex-col">{children}</section>
    </section>
  );
};
